import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Application } from './models';
import { CurrentApplicationService } from './services';

@Component({
    selector: 'app-application',
    templateUrl: './application.component.html',
    styleUrls: ['./application.component.scss'],
    standalone: false
})
export class ApplicationComponent implements OnDestroy {
    application: Application | undefined;
    subscription: Subscription | undefined;

    constructor(
        private _currentApplication: CurrentApplicationService,
        private _router: Router
    ) {
        this._currentApplication.reset();
        this._currentApplication.load();
        this.subscription = this._currentApplication.latest
            .pipe(
                filter(
                    (application) =>
                        application !== null &&
                        application !== undefined &&
                        application.applicationId != undefined
                )
            )
            .subscribe((application) => {
                this.application = new Application({ ...application });
                this._router.navigateByUrl(this.nextPage(this.application));
            });
        document
            .getElementsByTagName('body')[0]
            .classList.remove('blue-background-active');
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    nextPage(application: Application | undefined) {
        if (application?.isSubmitted) {
            return `${runtimeConfig.clientCode}/application-submitted`;
        } else {
            if (application?.isDisclosureComplete)
                return `${runtimeConfig.clientCode}/application-confirmed`;
            else if (application?.isEducationComplete)
                return `${runtimeConfig.clientCode}/application/disclosure`;
            else if (application?.isBackgroundComplete)
                return `${runtimeConfig.clientCode}/application/your-education`;
            else if (application?.isPersonalInfoComplete)
                return `${runtimeConfig.clientCode}/application/background`;
            else if (
                (application?.selectedProviderIds &&
                    application?.selectedProviderIds?.length > 0) ||
                sessionStorage.getItem('applicationProviderIds') !== null
            )
                return `${runtimeConfig.clientCode}/application/personal-information`;
            else return `${runtimeConfig.clientCode}/provider`;
        }
    }
    navigation(route: string) {
        this._router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }
}
